import React from 'react';

import LessonLocaleTabs from './LessonLocaleTabs';

const LessonLocaleTabsContainer = ({
  activeLocale,
  availableLocales,
  localesWithContent,
  onLocaleChange,
}: {
  lessonId: string;
  lessonType: string;
  activeLocale: string;
  availableLocales: readonly string[];
  localesWithContent: string[];
  onLocaleChange: (locale: string) => void;
}) => (
  <LessonLocaleTabs
    activeLocale={activeLocale}
    availableLocales={availableLocales}
    localesWithContent={localesWithContent}
    onLocaleChange={onLocaleChange}
  />
);

export default React.memo(LessonLocaleTabsContainer) as any;
